export function mapErrorMessage(id) {
  const errorMap = {
    invalidToken: { message: "Tu sesión ha expirado" },
    systemError: { message: "Ha ocurrido un error, por favor volvé a probar" },
    paymentMethodsError: {
      message:
        "Lo sentimos, no tenés medios de pago habilitados para continuar",
      cta: "VOLVER"
    },
    invalidBrowser: {
      message:
        "Tu navegador no es compatible. Por favor accedé a través de Google Chrome",
      cta: "ACEPTAR"
    }
  };

  return errorMap[id] ? errorMap[id] : "Ha ocurrido un error";
}
